module.exports = __webpack_public_path__ + "static/media/picketTitle.b318bca4.jpg";